/*
 * Vision v12 c3 (2.5) · verificação de licença Sabinov (reescrita legível)
 * Mesma regra de antes: consulta app.sabinovision.com.br/api/theme/verify com o
 * domínio da loja e o id do tema; se a resposta não for 200, envia a loja para o
 * caminho que a API devolver.
 * O que mudou para a velocidade:
 *  - sem trava anti-debug ("Paused in debugger") e sem desligar o console;
 *  - roda depois do carregamento, quando o navegador está ocioso;
 *  - resultado válido guardado por 8 horas no navegador (v12 c3; antes 5 minutos);
 *  - consulta abandonada após 8 s sem resposta (não redireciona; tenta na próxima página);
 *  - ~1 KB em vez de 38 KB de código ofuscado.
 */
(function () {
  'use strict';

  var API = 'https://app.sabinovision.com.br';
  var TEMA_ID = '68aced48ecaeddbef9c503c3';
  var CHAVE = 'vision-licenca';
  var VALIDADE_MS = 8 * 60 * 60 * 1000; // 8 horas
  var LIMITE_MS = 8000;

  var loja = window.Shopify && window.Shopify.shop;
  if (!loja) return;

  function lerCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CHAVE) || 'null');
      return c && c.loja === loja && Date.now() - c.em < VALIDADE_MS;
    } catch (e) {
      return false;
    }
  }

  function salvarCache() {
    try {
      localStorage.setItem(CHAVE, JSON.stringify({ loja: loja, em: Date.now() }));
    } catch (e) {}
  }

  function verificar() {
    if (lerCache()) return;
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, LIMITE_MS) : null;
    fetch(API + '/api/theme/verify?domain=' + encodeURIComponent(loja) + '&themeId=' + TEMA_ID, {
      credentials: 'omit',
      priority: 'low',
      signal: ctrl ? ctrl.signal : undefined,
    })
      .then(function (r) {
        if (r.status === 200) {
          salvarCache();
          return;
        }
        return r.json().then(function (dados) {
          if (dados && dados.path) window.location.href = API + dados.path;
        });
      })
      .catch(function () {})
      .then(function () {
        if (timer) clearTimeout(timer);
      });
  }

  function quandoOcioso() {
    if ('requestIdleCallback' in window) requestIdleCallback(verificar, { timeout: 4000 });
    else setTimeout(verificar, 1500);
  }

  if (document.readyState === 'complete') quandoOcioso();
  else window.addEventListener('load', quandoOcioso, { once: true });
})();
